import apiWorker from '../apiWorker'

export default {

    findByCase : (case_id) => apiWorker('get', `/api/v1/core/documents/findByCase/${case_id}`)

}
